import { CourseEnum, ModuleCourse } from './course-general'

export const instructorsEng = [
  {
    id: 1,
    username: 'Quan Dang',
    position: 'Founder & CEO',
    description: 'Senior Data Scientist at Yokogawa Singapore with over 8 years of industry experience.',
    avatar: '/images/founder.webp',
    transform: 'translateY(14px) scale(1.3)',
    linkedin: 'https://www.linkedin.com/in/quan-dang/',
    course: CourseEnum.MLOps,
    module: ModuleCourse.AIDE,
    experience: 8,
    status: 'active',
  },
  {
    id: 2,
    username: 'Quy Dinh',
    position: 'Senior Machine Learning Engineer',
    description: 'Senior Machine Learning Engineer at Grab Singapore with over 7 years of industry experience.',
    avatar: '/images/instructors/quy-dinh.jpeg',
    experience: 7,
    company: 'Grab Singapore',
    transform: '',
    course: CourseEnum.RECOMMENDER_SYSTEM,
    module: ModuleCourse.DSAA,
    linkedin: 'https://sg.linkedin.com/in/dvquy',
    status: 'deprecated',
  },
  {
    id: 3,
    username: 'Duc Luong',
    position: 'Machine Learning Tech Lead',
    description: 'Machine Learning Tech Lead at GeoComply with over 7 years of industry experience.',
    avatar: '/images/instructors/duc-luong.jpg',
    company: 'GeoComply',
    transform: 'translateY(14px) scale(1.3)',
    experience: 7,
    course: CourseEnum.DATA_ENGINEERING,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/max-luong',
    status: 'deprecated',
  },
  {
    id: 4,
    username: 'Tu Tran',
    position: 'Research Scientist',
    description: 'Research Scientist at Knorex with over 5 years of industry experience.',
    avatar: '/images/instructors/tu-tran.jpg',
    company: 'Knorex',
    transform: 'translateY(14px) scale(1.6)',
    experience: 5,
    course: CourseEnum.NATURAL_LANGUAGE_PROCESSING,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/tu-tran-3748a1287/',
    status: 'deprecated',
  },
  {
    id: 5,
    username: 'Hoang Pham',
    position: 'Head of AI & Lecturer',
    description:
      'Head of AI at OLLI Technology & Lecturer at VNUHCM University of Science with over 13 years of industry experience.',
    avatar: '/images/instructors/hoang-pham.jpg',
    company: 'OLLI Technology',
    transform: 'translateY(14px) scale(1.3)',
    experience: 13,
    course: CourseEnum.COMPUTER_VISION,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/hoang-pham-minh-b4746640/',
    status: 'deprecated',
  },
  {
    id: 6,
    username: 'Thach Le',
    position: 'Data Science Manager',
    description: 'Data Science Manager at MoMo with over 10 years of industry experience.',
    avatar: '/images/instructors/thach-le.png',
    company: 'MoMo',
    transform: 'translateY(10px) scale(1.2)',
    experience: 10,
    course: CourseEnum.LLM,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/ngocthach1207/',
    status: 'deprecated',
  },
  {
    id: 7,
    username: 'Quan Huynh',
    position: 'Data Science Manager',
    description: 'Data Science Manager at HCLTech with over 8 years of industry experience.',
    avatar: '/images/instructors/quan-huynh.jpeg',
    company: 'HCLTech',
    transform: 'translateY(14px) scale(1.3)',
    experience: 8,
    course: CourseEnum.MACHINE_LEARNING,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/charles-huynh/',
    status: 'deprecated',
  },
  {
    id: 8,
    username: 'Huy Nguyen',
    position: 'Analytics Engineer Manager',
    description: 'Analytics Engineer Manager at ZITGA STUDIO with over 6 years of industry experience.',
    avatar: '/images/instructors/huy-data.jpeg',
    company: 'ZITGA STUDIO',
    transform: 'translateY(14px) scale(1.3)',
    experience: 6,
    course: CourseEnum.BUSINESS_INTELLIGENCE,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/nguyen-tien-huy-8b0934212/',
    status: 'deprecated',
  },
  {
    id: 9,
    username: 'Nguyen Pham',
    position: 'Senior MLOps Engineer',
    description: 'Senior MLOps Engineer at MoMo with over 5 years of industry experience.',
    avatar: '/images/instructors/nguyen-pham.jpg',
    company: 'MoMo',
    transform: 'translateY(14px) scale(1.2)',
    experience: 5,
    course: CourseEnum.MLOps,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/nguyen-pham-877a531a9/',
    status: 'active',
  },
  {
    id: 10,
    username: 'Duc Nguyen',
    position: 'Senior Data Scientist',
    description: 'Senior Data Scientist at Mobifone IT Center with over 5 years of industry experience.',
    avatar: '/images/instructors/duc-nguyen.jpg',
    company: 'Mobifone IT Center',
    transform: 'translateY(10px) scale(1.2)',
    experience: 5,
    course: CourseEnum.SPEECH,
    module: ModuleCourse.DSAA,
    linkedin: 'https://www.linkedin.com/in/sy-duc-nguyen-433a12235/',
    status: 'deprecated',
  },
  {
    id: 11,
    username: 'Quan Huynh',
    position: 'Data Science Manager',
    description: 'Data Science Manager at HCLTech with over 8 years of industry experience.',
    avatar: '/images/instructors/quan-huynh.jpeg',
    company: 'HCLTech',
    transform: 'translateY(14px) scale(1.3)',
    experience: 8,
    course: CourseEnum.DEEP_LEARNING,
    module: ModuleCourse.FSWE,
    linkedin: 'https://www.linkedin.com/in/charles-huynh/',
    status: 'deprecated',
  },
]

export type InstructorType = (typeof instructorsEng)[number]
